import { Events, Properties } from '../../enums/Analytics';
import Analytics from '../../tools/Analytics';

export type DsrDeepLinkActor = 'buyer' | 'seller';

export type DsrAssetLinkEntryPoint =
  | 'builder_menu'
  | 'builder_section'
  | 'buyer_hover_icon';

export type DsrDeepLinkTargetType = 'asset' | 'section';

export const DsrHideSectionToggledEntryPointEnum = {
  SIDE_MENU: 'side_menu',
  TOP_MENU: 'top_menu',
  EYE_ICON: 'eye_icon',
} as const;

export type DsrHideSectionToggledEntryPoint =
  (typeof DsrHideSectionToggledEntryPointEnum)[keyof typeof DsrHideSectionToggledEntryPointEnum];

export const DsrHideSectionToggledToEnum = {
  HIDE: 'hide',
  UNHIDE: 'unhide',
} as const;

export type DsrHideSectionToggledTo =
  (typeof DsrHideSectionToggledToEnum)[keyof typeof DsrHideSectionToggledToEnum];

export const getDsrHideSectionToggledTo = (
  wasVisible: boolean
): DsrHideSectionToggledTo =>
  wasVisible
    ? DsrHideSectionToggledToEnum.HIDE
    : DsrHideSectionToggledToEnum.UNHIDE;

export function trackDsrAssetLinkCopied(params: {
  actor: DsrDeepLinkActor;
  assetId: string;
  assetType: string;
  entryPoint: DsrAssetLinkEntryPoint;
  roomId: string;
}): void {
  Analytics.track(Events.DSR_ASSET_LINK_COPIED, {
    [Properties.ROOM_ID]: params.roomId,
    [Properties.ASSET_ID]: params.assetId,
    [Properties.ASSET_TYPE]: params.assetType,
    [Properties.DSR_ACTOR]: params.actor,
    [Properties.DSR_ENTRY_POINT]: params.entryPoint,
  });
}

export function trackDsrSectionLinkCopied(params: {
  actor: DsrDeepLinkActor;
  roomId: string;
  sectionId: string;
  sectionName: string;
}): void {
  Analytics.track(Events.DSR_SECTION_LINK_COPIED, {
    [Properties.ROOM_ID]: params.roomId,
    [Properties.SECTION_ID]: params.sectionId,
    [Properties.SECTION_NAME]: params.sectionName,
    [Properties.DSR_ACTOR]: params.actor,
  });
}

export function trackDsrDeepLinkAccessed(params: {
  authRequired: boolean;
  roomId: string;
  targetId: string;
  targetType: DsrDeepLinkTargetType;
}): void {
  Analytics.track(Events.DSR_DEEP_LINK_ACCESSED, {
    [Properties.ROOM_ID]: params.roomId,
    [Properties.DSR_TARGET_TYPE]: params.targetType,
    [Properties.DSR_TARGET_ID]: params.targetId,
    [Properties.DSR_AUTH_REQUIRED]: params.authRequired,
  });
}

export function trackDsrHideSectionToggled(params: {
  entryPoint: DsrHideSectionToggledEntryPoint;
  roomId: string;
  sectionId: string;
  sectionName: string;
  toggledTo: DsrHideSectionToggledTo;
}): void {
  Analytics.track(Events.DSR_HIDE_SECTION_TOGGLED, {
    [Properties.ROOM_ID]: params.roomId,
    [Properties.SECTION_ID]: params.sectionId,
    [Properties.SECTION_NAME]: params.sectionName,
    [Properties.DSR_ENTRY_POINT]: params.entryPoint,
    [Properties.TOGGLED_TO]: params.toggledTo,
  });
}
